import "./AdManagerAdvertisingZone.scss";
import axios from "axios";
import AdManagerAdvertisingZonesFilter from "@/components/AdManager/AdManagerAdvertisingZonesFilter/AdManagerAdvertisingZonesFilter.vue";
import AdManagerAdvertisingZoneEditDialog from "@/components/AdManager/AdManagerAdvertisingZoneEditDialog/AdManagerAdvertisingZoneEditDialog.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import {
  AdvertisingZonePlacementOptions,
  AdvertisingZoneTargetOptions,
  getPrincipalsWithAdZoneInAppdinxLogin
} from "@/helpers/adManagerHelper";
import { updateAllNewsInApp } from "@/helpers/newsHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerAdvertisingZone",
  components: {
    AdManagerAdvertisingZonesFilter,
    AdManagerAdvertisingZoneEditDialog
  },
  data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Konfiguriert für", value: "target" },
      { text: "Platzierung", value: "placement" },
      { text: "Format", value: "format" },
      { text: "Rotation", value: "rotation_enabled" },
      { text: "Anzeigenkennung", value: "display_is_advert_information" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    itemsPerPage: 10,
    placementOptions: { ...AdvertisingZonePlacementOptions },
    targetOptions: [...AdvertisingZoneTargetOptions],
    formats: [],
    zones: [],
    total: 0,
    options: {},
    loading: true,
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    page: 1,
    pageCount: 0,
    search: "",
    editDialog: false,
    editedItem: null,
    filter: {
      targets: [],
      placements: [],
      formats: [],
      active: -1
    }
  }),
  async mounted() {
    await this.$store.dispatch("getPrincipals");
    await this.loadFormats();
    await this.loadZones();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal?.id;
    }
  },
  methods: {
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) this.page++;
    },
    previousPage() {
      if (this.page > 1) this.page--;
    },
    formatDate(d) {
      return new Date(d).toLocaleDateString("de-DE");
    },
    getSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      return {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy?.[0] || "name",
        direction: sortDesc?.[0] ? "desc" : "asc",
        ...this.filter
      };
    },
    async loadFormats() {
      const headers = getTokenHeader();
      this.loading = true;
      try {
        const r = await axios.get(
          env.ad_manager_api_client_url + "ad/formats",
          {
            headers,
            params: { principal_id: this.currentPrincipal }
          }
        );
        this.formats = r.data || [];
      } finally {
        this.loading = false;
      }
    },
    async loadZones() {
      const headers = getTokenHeader();
      this.loading = true;
      try {
        const r = await axios.get(env.ad_manager_api_client_url + "ad/zones", {
          headers,
          params: this.getSearchParams()
        });
        this.zones = r.data || [];
        const count = parseInt(r?.headers?.["x-count"]);
        this.total = isNaN(count) ? this.zones.length : count;
      } finally {
        this.loading = false;
      }
    },
    createItem() {
      this.editedItem = {
        _id: "",
        principal_id: this.currentPrincipal,
        target: "website",
        name: "",
        format: null,
        placement: null,
        rotation_enabled: false,
        rotation_seconds: 4,
        active: true,
        display_is_advert_information: true
      };
      this.editDialog = true;
    },
    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    async deleteItem(item) {
      const ok = await this.$confirm?.(
        `Werbezone <b>${item.name}</b> wirklich löschen?`,
        confirmWarningConfig
      );
      if (!ok) return;
      const headers = getTokenHeader();
      await axios.delete(
        env.ad_manager_api_client_url + "ad/zones/" + item._id,
        {
          headers,
          params: { principal_id: this.currentPrincipal }
        }
      );

      if (item.active && item.target === "app") {
        getPrincipalsWithAdZoneInAppdinxLogin(item._id).forEach(principal => {
          updateAllNewsInApp(principal.id, headers);
        });
      }

      await this.loadZones();
      await this.$store.dispatch("createSuccess", "Werbezone gelöscht");
    },
    async afterSave() {
      await this.loadZones();
      await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
    },
    close() {
      this.editDialog = false;
      this.$nextTick(() => (this.editedItem = null));
    },
    getTargetLabel(target) {
      const label = this.targetOptions.find(option => option.value === target)
        ?.label;
      return label ?? "---";
    },
    getPlacementLabel(item) {
      const placementOptions = this.placementOptions[item.target];
      if (!placementOptions?.length) {
        return "---";
      }
      const label = placementOptions.find(
        option => option.value === item.placement
      )?.label;
      return label ?? "---";
    }
  },
  watch: {
    options() {
      this.loadZones();
    },
    search(val) {
      if (val?.length >= 3 || val === "") this.loadZones();
    },
    currentPrincipal() {
      this.loadFormats();
      this.loadZones();
    }
  }
};
